// extracted by mini-css-extract-plugin
export default {"recProductC":"index_recProductC__qN0LF","popTitle":"index_popTitle__yjNKK","close":"index_close__kPI-L","list":"index_list__5AWiE","safeBottom":"index_safeBottom__UPF7a"};